<template>
  <mu-row>
    <mu-col desktop="30" width="100" tablet="20"></mu-col>
    <mu-col desktop="40" width="100" tablet="60">
      <create-question class="animated fadeInUp"></create-question>
    </mu-col>
    <mu-col desktop="30" width="100" tablet="20"></mu-col>
  </mu-row>
</template>
<script>
  import CreateQuestion from "../../components/Questions/CreateQuestion/CreateQuestion";
  import UserAvatar from "../../components/UserAvatar/UserAvatar";


  export default {
    components: {
      UserAvatar,
      CreateQuestion
    },
    name: 'ask-a-question',
    data () {
      return {}
    },
    mounted() {
      let self = this;
      self.$gtag.pageview('/questions/create');
    }
  }

</script>



// WEBPACK FOOTER //
// QuestionCreate.vue?13ed86a2